var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._b({staticClass:"quill-view",domProps:{"innerHTML":_vm._s(_vm.displayValue)}},'div',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }